// @ts-nocheck
import type { Question } from '../types';

export const overtakingQuestions: Question[] = [
  {
    id: 'q-ot-1',
    topic: 'General',
    question: 'You see a dashed white line between your lane and the lane ahead. What does this mean?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/overtaking/overtaking-1-dashed-line.png',
    options: [
      { id: 'q-ot-1o1', text: 'Overtaking is prohibited' },
      { id: 'q-ot-1o2', text: 'Overtaking is permitted when safe and the road ahead is clear' },
      { id: 'q-ot-1o3', text: 'You must overtake immediately' }
    ],
    answerId: 'q-ot-1o2',
    explanation: 'A dashed white line (broken line) allows overtaking when it is safe to do so. You must still check for oncoming traffic and ensure the road ahead is clear for a safe distance. (RVV 1990 art. 40)',
    subject: 'Overtaking',
    animationId: null,
  },
  {
    id: 'q-ot-2',
    topic: 'General',
    question: 'You see a solid white line between your lane and the lane ahead. What does this prohibit?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/overtaking/overtaking-2-solid-line.png',
    options: [
      { id: 'q-ot-2o1', text: 'You may overtake if the road is clear' },
      { id: 'q-ot-2o2', text: 'Overtaking is prohibited; do not cross this line' },
      { id: 'q-ot-2o3', text: 'You must overtake before the line ends' }
    ],
    answerId: 'q-ot-2o2',
    explanation: 'A solid white line prohibits crossing. You must not overtake when a solid white line is on your side of the road. It means the road layout or visibility does not permit safe overtaking. (RVV 1990 art. 40)',
    subject: 'Overtaking',
    animationId: null,
  },
  {
    id: 'q-ot-3',
    topic: 'General',
    question: 'Before overtaking, how far ahead must you be able to see clearly?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/overtaking/overtaking-3-300m-sight.png',
    options: [
      { id: 'q-ot-3o1', text: '100 metres' },
      { id: 'q-ot-3o2', text: '300 metres minimum' },
      { id: 'q-ot-3o3', text: 'Only 50 metres is needed' }
    ],
    answerId: 'q-ot-3o2',
    explanation: 'You must be able to see at least 300 metres ahead and be certain the oncoming lane is clear for the entire overtaking manoeuvre. Never overtake if you cannot see far enough ahead to be safe. (RVV 1990 art. 40)',
    subject: 'Overtaking',
    animationId: null,
  },
  {
    id: 'q-ot-4',
    topic: 'General',
    question: 'Why is overtaking more dangerous at night?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/overtaking/overtaking-4-night-driving.png',
    options: [
      { id: 'q-ot-4o1', text: 'Oncoming vehicles are harder to see; you cannot see as far ahead with headlights' },
      { id: 'q-ot-4o2', text: 'Night driving is not more dangerous' },
      { id: 'q-ot-4o3', text: 'Other drivers always use main beam at night' }
    ],
    answerId: 'q-ot-4o1',
    explanation: 'At night, visibility is severely limited. Oncoming vehicles are hard to spot, and your headlights only show a limited distance ahead. Do not overtake unless you can see clearly that the road ahead is completely free. (RVV 1990 art. 40)',
    subject: 'Overtaking',
    animationId: null,
  },
  {
    id: 'q-ot-5',
    topic: 'General',
    question: 'Before you overtake, what must you check regarding oncoming traffic?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/overtaking/overtaking-5-oncoming-traffic.png',
    options: [
      { id: 'q-ot-5o1', text: 'Check mirrors and be certain no oncoming vehicle is approaching in the lane you plan to use' },
      { id: 'q-ot-5o2', text: 'Oncoming traffic will move aside' },
      { id: 'q-ot-5o3', text: 'No need to check; flash your lights to warn them' }
    ],
    answerId: 'q-ot-5o1',
    explanation: 'Before overtaking, you must check your mirrors and look ahead to be absolutely certain no oncoming vehicle is approaching. You must have enough clear road to complete the entire overtaking manoeuvre safely. (RVV 1990 art. 40)',
    subject: 'Overtaking',
    animationId: null,
  },
  {
    id: 'q-ot-6',
    topic: 'General',
    question: 'You see a left turn sign ahead. Is it safe to overtake?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/overtaking/overtaking-6-left-turn-sign.jpg',
    options: [
      { id: 'q-ot-6o1', text: 'Yes, as long as you are fast' },
      { id: 'q-ot-6o2', text: 'No; do not overtake where there is a junction or turning ahead' },
      { id: 'q-ot-6o3', text: 'Yes, if no oncoming traffic is visible' }
    ],
    answerId: 'q-ot-6o2',
    explanation: 'Do not overtake near junctions, turnings, or road signs indicating a junction ahead. A vehicle may turn into your path unexpectedly. Wait until you have passed the junction before overtaking. (RVV 1990 art. 40)',
    subject: 'Overtaking',
    animationId: null,
  },
  {
    id: 'q-ot-7',
    topic: 'General',
    question: 'You are approaching a bus stop. Is it safe to overtake the vehicle in front?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/overtaking/overtaking-7-bus-halte.png',
    options: [
      { id: 'q-ot-7o1', text: 'Yes, quickly before the bus moves' },
      { id: 'q-ot-7o2', text: 'No; do not overtake near bus stops — passengers may cross the road' },
      { id: 'q-ot-7o3', text: 'Only if the bus is not moving' }
    ],
    answerId: 'q-ot-7o2',
    explanation: 'Do not overtake near bus stops. Passengers are crossing or about to cross the road, and visibility may be blocked. Wait until you have passed the stop and the road is clear. (RVV 1990 art. 40)',
    subject: 'Overtaking',
    animationId: null,
  },
  {
    id: 'q-ot-8',
    topic: 'General',
    question: 'After completing an overtake, how much space must you have before returning to your original lane?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/overtaking/overtaking-8-safe-spacing.png',
    options: [
      { id: 'q-ot-8o1', text: 'Any gap is acceptable' },
      { id: 'q-ot-8o2', text: 'You must have passed the vehicle completely and have a safe distance between you' },
      { id: 'q-ot-8o3', text: 'You can cut back as soon as your car is ahead' }
    ],
    answerId: 'q-ot-8o2',
    explanation: 'You must completely pass the vehicle and ensure there is a safe distance between you before returning to your lane. Cutting back too early can clip the rear of the vehicle or force the driver to brake. (RVV 1990 art. 40)',
    subject: 'Overtaking',
    animationId: null,
  },
  {
    id: 'q-ot-9',
    topic: 'General',
    question: 'In which situations must you never overtake?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/overtaking/overtaking-9-prohibited-scenarios.jpg',
    options: [
      { id: 'q-ot-9o1', text: 'At zebra crossings, level crossings, junctions, and when visibility is poor' },
      { id: 'q-ot-9o2', text: 'Overtaking is always allowed if you signal' },
      { id: 'q-ot-9o3', text: 'Only during rush hour' }
    ],
    answerId: 'q-ot-9o1',
    explanation: 'Never overtake: (1) at or near zebra crossings or pedestrian crossings, (2) at or near level crossings, (3) at or near junctions or turnings, (4) when visibility is reduced (fog, rain, night), (5) where there is a solid line on your side. (RVV 1990 art. 40)',
    subject: 'Overtaking',
    animationId: null,
  },
  {
    id: 'q-ot-10',
    topic: 'General',
    question: 'What is the correct overtaking procedure?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/overtaking/overtaking-10-safe-procedure.jpg',
    options: [
      { id: 'q-ot-10o1', text: 'Check mirrors and mirrors, signal, move out, pass, signal, return to lane' },
      { id: 'q-ot-10o2', text: 'Just move out and overtake' },
      { id: 'q-ot-10o3', text: 'Use the horn and overtake immediately' }
    ],
    answerId: 'q-ot-10o1',
    explanation: 'The correct procedure is: (1) Check mirrors to see traffic behind and ahead, (2) Check it is legal to overtake (no solid line), (3) Signal your intention to move left, (4) Move out smoothly, (5) Overtake with a safe distance, (6) Signal to return right, (7) Return to your lane when safe. (RVV 1990 art. 40)',
    subject: 'Overtaking',
    animationId: null,
  }
];
